// extracted by mini-css-extract-plugin
export default {"success_container":"successfulverification_success_container__3+gm3","success_title":"successfulverification_success_title__yCrQk"};